import React, { useMemo, useState, useRef  ,useEffect, useReducer, fetchData} from 'react';
import { Alert, Button, Container, Card, Table, Modal, Accordion,Form, FormLabel, Col, Row } from 'react-bootstrap';

import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {XLogOff, IsLoggedIn, Loading, SpinnerX, CallDownload} from '../../services/useBackend';
import MaterialReactTable from 'material-react-table';
import {getOptions} from '../../services/misc';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { FaFilePdf, FaReceipt, FaEnvelope,FaBars, FaUser, FaFileDownload, FaDownload } from 'react-icons/fa';
//import { mkConfig, generateCsv, download } from 'export-to-csv';

import download from 'downloadjs'
import { Link } from 'react-router-dom';

function SellReport() {

  const {loading, data, Refresh, Seek} =  useBackend('/api/report/invoice');
  
  var today = new Date(Date.now());
  var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const [startDate, setStartDate] = useState(firstDayOfMonth.toLocaleDateString());
  
  var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth()+1, 0);
  const [endDate, setEndDate] = useState(lastDayOfMonth.toLocaleDateString());

  const [hideResult, setHideResult] = useState(false);
  
  const [shopFilter, setShopFilter] = useState(0);

  const columns = useMemo(() => [
    { size: 20, accessorKey: 'Name',   header: 'Namn' },       
    { size: 10, accessorKey: 'SSN',  header: 'SSN' },                 
    { size: 10, accessorKey: 'Qty',  header: 'Antal köp' },                 
    { size: 10, accessorKey: 'TotalSum',  header: 'Belopp' },                 
    { size: 10, accessorKey: 'TotalVAT',  header: 'Varav moms' },                 
  ]);

  async function handleExportData(SoldProducts) {        
    const csv = await CallDownload("/api/report/invoice?startdate="+startDate+"&enddate="+endDate+"&Format=xls");
    download(csv, "invoicereport.csv", 'text/csv')
  };  

  useEffect(() => {
    if (startDate=="" || endDate=="" ) { setHideResult(true);} else {setHideResult(false);}
    if (Date.parse(endDate)<Date.parse(startDate) ) { setHideResult(true);}

     Seek("?startdate="+startDate+"&enddate="+endDate);
  }, [startDate, endDate, shopFilter]);

  return (
        <ContentWrapper>
        <Container>
            <Sida>
                <Rubrik>Faktureringsrapport</Rubrik>

                <div className='d-flex'></div>

                <Row>
                    <Col>Startdatum</Col>
                    <Col>Slutdatum</Col>
                </Row>

                <Row>
                    <Col><Form.Control type="date" name="Name" placeholder="Startdatum" value={startDate} onChange={async (e) => {await setStartDate(e.target.value); }} /></Col>
                    <Col><Form.Control type="date" name="Name_" placeholder="Slutdatum" value={endDate}   onChange={async (e) => {setEndDate(e.target.value); }} /></Col>
                    {/* <Col><Button variant='secondary' onClick={() => {Seek("?startdate="+startDate+"&enddate="+endDate+"&ShopId="+shopFilter)}}>Sök/Uppdatera</Button> </Col> */}
                </Row>

                {loading && <SpinnerX />}

                {hideResult && <><br></br><Alert variant="danger">OBS ovanstående datumkombination är ogiltlig!</Alert> </>}

                {!loading &&
                    (      
                    <>              
                        <br></br>

                        <MaterialReactTable 
                            enableColumnActions= {false}
                            columns={columns}
                            data={data.ToInvoice}
                            manualPagination= {true}
                            enablePagination={false}
                            enableBottomToolbar={false}

                            muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false ,labelRowsPerPage:"Rader", rowsPerPageOptions: [1000]}}
                            
                            renderTopToolbarCustomActions= {() => (
                              <div style={{width:"100%"}}>
                                <div style={{float:"left"}}>
                                <Rubrik>Underlag</Rubrik>
                                </div>

                                <div style={{float:"right"}}>
                                  <Button
                                    data={data.ToInvoice}
                                    onClick={() => handleExportData(data.ToInvoice)}         
                                    variant="outlined"
                                    title='Exportera CSV'
                                  >
                                    <FaDownload color="gray" />
                                  </Button>
                                </div>                             

                              </div>
                            )}
                                                          
                        />                                                             
                    </>                                                
                    )
                }
               
            </Sida>
        </Container>
    </ContentWrapper>        
  );
}

export default SellReport;